import { CreateOrUpdateCompanyCandidateMutation, useCreateOrUpdateCompanyCandidateMutation } from "@generated/graphql";
import { CandidateInputs } from "pages/Candidate/view/types";

export const isCandidateWithTelegramData = (value: unknown): value is CreateOrUpdateCompanyCandidateMutation => {
  return value !== null && typeof value === "object" && "createOrUpdateCompanyCandidate" in value;
};

const useUpdateCandidate = () => {
  const [updateCompanyCandidate, { loading }] = useCreateOrUpdateCompanyCandidateMutation();

  const onUpdateCompanyCandidate = ({ authSettingsSwitch, ...formData }: CandidateInputs) => {
    return updateCompanyCandidate({
      variables: {
        input: {
          ...formData,
          email: formData.email || undefined,
          login: formData.login || undefined,
          grade: formData.grade?.id,
          // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
          type: formData.type?.id!,
          cvFile: formData.cvFile instanceof File || formData.cvFile === null ? formData.cvFile : undefined,
          telegramUsername: formData.telegramUsername?.replaceAll("@", "") || undefined,
          yandexEmail: formData.yandexEmail || undefined,
          vkId: formData.vkId || undefined,
        },
      },
    });
  };

  return { onUpdateCompanyCandidate, updateCompanyCandidateLoading: loading };
};

export default useUpdateCandidate;
